module.exports = __webpack_public_path__ + "media/conmex/novedades-eb6e4cfe.png";